/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Modal, ModalProps, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { useStyles } from '~src/hooks/useStyles';
import { styleFn } from './style';

export interface RejectQuestionModalProps extends Partial<ModalProps> {
  isLoading?: boolean;
  onReject?: () => Promise<unknown>;
  onCancel?: () => void;
}
export const RejectQuestionModal: React.FC<RejectQuestionModalProps> = ({
  isLoading,
  onReject,
  onCancel,
  ...modalProps
}) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  return (
    <Modal
      title={
        <ModalTitle
          text={intl.formatMessage({ id: 'reject-question' })}
          icon={['far', 'ban']}
        />
      }
      okText={intl.formatMessage({ id: 'reject' })}
      cancelText={intl.formatMessage({ id: 'cancel' })}
      width={420}
      centered
      okButtonProps={{ danger: true, loading: isLoading }}
      onOk={async () => {
        await onReject?.();
        onCancel?.();
      }}
      onCancel={onCancel}
      {...modalProps}>
      <p css={styles.modalText}>
        {intl.formatMessage({ id: 'reject-question-full' })}
      </p>
    </Modal>
  );
};
